// import { motion, useMotionValue, animate } from "framer-motion";
// import { useEffect, useRef, useState } from "react";

// const reviews = [
//   {
//     name: "KP Bhatt",
//     company: "XP India",
//     text:
//       "Outstanding service! Their commitment to timely delivery and cargo safety is exceptional.",
//   },
//   {
//     name: "Pawan Jha",
//     company: "Apollo Supply Chain",
//     text:
//       "Reliable and professional. MSC Natraj Logistic Pvt. Ltd. has been our trusted partner for over 5 years.",
//   },
//   {
//     name: "Rahul Kumar",
//     company: "TCI Supply Chain",
//     text:
//       "Their pan-India network and 24/7 support make them the best choice for transportation needs.",
//   },
//   {
//     name: "Amit Verma",
//     company: "Flipkart Logistics",
//     text:
//       "Excellent coordination, safe handling, and always on-time deliveries.",
//   },
//   {
//     name: "Suresh Nair",
//     company: "Reliance Retail Logistics",
//     text:
//       "Consistent performance and dependable service across India.",
//   },
// ];

// const data = [...reviews, ...reviews];

// const Testimonials = () => {
//   const x = useMotionValue(0);
//   const controls = useRef(null);
//   const [paused, setPaused] = useState(false);

//   useEffect(() => {
//     if (!paused) {
//       controls.current = animate(x, [-0, -1600], {
//         duration: 40,
//         ease: "linear",
//         repeat: Infinity,
//       });
//     }

//     return () => controls.current?.stop();
//   }, [paused, x]);

//   return (
//     <section
//       style={{
//         position: "relative",
//         padding: "100px 0",
//         background:
//           "linear-gradient(180deg, #2b2f8f 0%, #4b2a7a 50%, #2b145f 100%)",
//         color: "white",
//         overflow: "hidden",
//       }}
//     >
//       {/* FADE EDGES */}
//       <div
//         style={{
//           position: "absolute",
//           top: 0,
//           bottom: 0,
//           left: 0,
//           width: "120px",
//           background:
//             "linear-gradient(90deg, #2b2f8f, transparent)",
//           zIndex: 5,
//         }}
//       />
//       <div
//         style={{
//           position: "absolute",
//           top: 0,
//           bottom: 0,
//           right: 0,
//           width: "120px",
//           background:
//             "linear-gradient(270deg, #2b145f, transparent)",
//           zIndex: 5,
//         }}
//       />

//       {/* HEADING */}
//       <div style={{ textAlign: "center", marginBottom: "60px" }}>
//         <h2 style={{ fontSize: "42px", marginBottom: "10px" }}>
//           What Our Clients Say
//         </h2>
//         <p style={{ opacity: 0.85 }}>
//           Trusted by leading enterprises across India
//         </p>
//       </div>

//       {/* SCROLLER */}
//       <motion.div
//         style={{
//           display: "flex",
//           gap: "30px",
//           x,
//         }}
//       >
//         {data.map((item, index) => (
//           <motion.div
//             key={index}
//             onHoverStart={() => {
//               setPaused(true);
//               controls.current?.stop();
//             }}
//             onHoverEnd={() => {
//               setPaused(false);
//             }}
//             whileHover={{
//               scale: 1.08,
//               zIndex: 10,
//             }}
//             transition={{ type: "spring", stiffness: 180, damping: 18 }}
//             style={{
//               minWidth: "320px",
//               maxWidth: "320px",
//               padding: "32px",
//               borderRadius: "18px",
//               background:
//                 "linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0.06))",
//               backdropFilter: "blur(8px)",
//               boxShadow: "0 30px 70px rgba(0,0,0,0.35)",
//               cursor: "pointer",
//             }}
//           >
//             <h4 style={{ marginBottom: "4px" }}>{item.name}</h4>
//             <p style={{ fontSize: "14px", color: "#9ecbff" }}>
//               {item.company}
//             </p>

//             <div style={{ margin: "12px 0", color: "#ffd700" }}>
//               ★★★★★
//             </div>

//             <p
//               style={{
//                 fontSize: "14px",
//                 lineHeight: "1.6",
//                 opacity: 0.95,
//               }}
//             >
//               “{item.text}”
//             </p>
//           </motion.div>
//         ))}
//       </motion.div>
//     </section>
//   );
// };

// export default Testimonials;

// above one is for purple color and this below one is blue 
import { motion, useMotionValue, animate } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const reviews = [
  {
    name: "KP Bhatt",
    company: "XP India",
    text:
      "Outstanding service! Their commitment to timely delivery and cargo safety is exceptional.",
  },
  {
    name: "Pawan Jha",
    company: "Apollo Supply Chain",
    text:
      "Reliable and professional. MSC Natraj Logistic Pvt. Ltd. has been our trusted partner for over 5 years.",
  },
  {
    name: "Rahul Kumar",
    company: "TCI Supply Chain",
    text:
      "Their pan-India network and 24/7 support make them the best choice for transportation needs.",
  },
  {
    name: "Amit Verma",
    company: "Flipkart Logistics",
    text:
      "Excellent coordination, safe handling, and always on-time deliveries.",
  },
  {
    name: "Suresh Nair",
    company: "Reliance Retail Logistics",
    text:
      "Consistent performance and dependable service across India.",
  },
];

const data = [...reviews, ...reviews];

const Testimonials = () => {
  const x = useMotionValue(0);
  const controls = useRef(null);
  const [paused, setPaused] = useState(false);

  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (paused && !isMobile) return;

    controls.current = animate(
      x,
      [0, isMobile ? -1200 : -1600],
      {
        duration: isMobile ? 55 : 40,
        ease: "linear",
        repeat: Infinity,
      }
    );

    return () => controls.current?.stop();
  }, [paused, isMobile, x]);

  return (
    <section
      style={{
        position: "relative",
        padding: isMobile ? "100px 0" : "120px 0",
        background: "#1e3a8a",
        color: "white",
        overflow: "hidden",
      }}
    >
      {/* FADE EDGES */}
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          width: isMobile ? "60px" : "120px",
          background: "linear-gradient(90deg, #1e3a8a, transparent)",
          zIndex: 5,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 0,
          width: isMobile ? "60px" : "120px",
          background: "linear-gradient(270deg, #1e3a8a, transparent)",
          zIndex: 5,
        }}
      />

      {/* HEADING */}
      <div style={{ textAlign: "center", marginBottom: "70px" }}>
        <h2 style={{ fontSize: isMobile ? "34px" : "44px", marginBottom: "12px" }}>
          What Our Clients Say
        </h2>
        <p style={{ opacity: 0.9, color: "#dbeafe" }}>
          Trusted by leading enterprises across India
        </p>
      </div>

      {/* SCROLLER */}
      <motion.div
        style={{
          display: "flex",
          gap: isMobile ? "20px" : "30px",
          x,
          paddingLeft: isMobile ? "20px" : "0px",
        }}
      >
        {data.map((item, index) => (
          <motion.div
            key={index}
            onMouseEnter={() => !isMobile && setPaused(true)}
            onMouseLeave={() => !isMobile && setPaused(false)}
            whileHover={
              !isMobile
                ? {
                    scale: 1.06,
                    zIndex: 10,
                  }
                : {}
            }
            transition={{ type: "spring", stiffness: 180, damping: 18 }}
            style={{
              minWidth: isMobile ? "260px" : "320px",
              maxWidth: isMobile ? "260px" : "320px",
              padding: isMobile ? "24px" : "34px",
              borderRadius: "20px",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.16), rgba(255,255,255,0.06))",
              backdropFilter: "blur(14px)",
              boxShadow: "0 30px 70px rgba(0,0,0,0.35)",
              cursor: !isMobile ? "pointer" : "default",
            }}
          >
            <h4 style={{ marginBottom: "4px" }}>{item.name}</h4>

            <p style={{ fontSize: "14px", color: "#bfdbfe" }}>
              {item.company}
            </p>

            <div style={{ margin: "10px 0", color: "#facc15" }}>
              ★★★★★
            </div>

            <p
              style={{
                fontSize: "14px",
                lineHeight: "1.7",
                color: "#e5edff",
              }}
            >
              “{item.text}”
            </p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Testimonials;
